import React from 'react';
import { ShieldCheck } from 'lucide-react';

const TrustSection = () => {
  return (
    <section className="trust-section">
      <div className="trust-container">
        <div className="pinky-promise-header">
          <h3 className="trust-title">Our Pinky Promise</h3>
        </div>
        
        <div className="trust-content-box">
          <div className="trust-icon-wrapper">
            <ShieldCheck className="trust-icon" />
          </div>
          <p className="trust-message-main">
            The price you see is <span className="trust-highlight-bold">the price you pay</span>.
          </p>
          <p className="trust-message-detail">
            All our listed prices are fully inclusive of GST with{' '}
            <span className="trust-highlight">absolutely zero hidden charges</span>.
          </p>
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
